export const columns = () => {
  return [
    {
      accessorKey: "sport",
      header: "Sport ID",
      cell: ({ row }) => <div>{row.original?.sport?.code}</div>,
    },
    {
      accessorKey: "team",
      header: "Team",
      cell: ({ row }) => <div>{row.original?.participant?.name}</div>,
    },
    {
      accessorKey: "competition",
      header: "Competition",
      cell: ({ row }) => <div>{row.original?.competition?.name}</div>,
    },
    {
      accessorKey: "team_code",
      header: "Team ID",
      cell: ({ row }) => <div>{row.original?.participant?.code}</div>,
    },
    {
      accessorKey: "competition_code",
      header: "Competition ID",
      cell: ({ row }) => <div>{row.original?.competition?.code}</div>,
    },
    {
      accessorKey: "term_code",
      header: "Term ID",
      cell: ({ row }) => <div>{row.original?.term?.code}</div>,
    },

    {
      accessorKey: "rank",
      header: "Rank",
    },
  ];
};
